(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ajax-search"] && !Shopify.designMode) return;
  try {
    (function () {
    var searchRoot = document.querySelector('[data-ajax-search]');
    var searchOpen = document.querySelector('[data-search-open]');
    if (!searchRoot || !searchOpen) return;

    var searchInput = searchRoot.querySelector('[data-search-input]');
    var searchResults = searchRoot.querySelector('[data-search-results]');
    var searchForm = searchRoot.querySelector('[data-search-form]');
    var closeBtns = searchRoot.querySelectorAll('[data-search-close]');
    var suggestUrl = searchRoot.getAttribute('data-suggest-url') || '/search/suggest';
    var searchUrl = searchRoot.getAttribute('data-search-url') || '/search';
    var moneyFormat = searchRoot.getAttribute('data-money-format') || '$AMOUNT';
    var hint = searchRoot.getAttribute('data-hint') || 'Start typing to search products';
    var timer;
    var requestId = 0;

    function escapeHtml(value) {
      return String(value || '').replace(/[&<>"']/g, function (ch) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
      });
    }

    function emptyMessage(terms) {
      return 'No results found for “' + escapeHtml(terms) + '”.';
    }

    function currentQuery() {
      return searchInput ? String(searchInput.value || '').trim() : '';
    }

    function formatMoney(price) {
      var cents;
      if (typeof price === 'string' && /[.,]/.test(price)) {
        cents = Math.round(parseFloat(price.replace(',', '.')) * 100);
      } else {
        cents = parseInt(price, 10) || 0;
      }
      var value = (cents / 100).toFixed(2);
      return moneyFormat
        .replace(/amount_no_decimals/g, String(Math.round(cents / 100)))
        .replace(/amount/g, value)
        .replace(/[{}]/g, '');
    }

    function productImage(product) {
      if (!product) return '';
      if (typeof product.featured_image === 'string') return product.featured_image;
      if (product.featured_image && product.featured_image.url) return product.featured_image.url;
      if (typeof product.image === 'string') return product.image;
      if (product.image && product.image.src) return product.image.src;
      return '';
    }

    function extractProducts(data) {
      if (!data) return [];
      if (data.resources && data.resources.results && data.resources.results.products) {
        return data.resources.results.products;
      }
      if (Array.isArray(data.results)) return data.results;
      return [];
    }

    function parseJsonSafe(text) {
      try {
        return JSON.parse(text);
      } catch (error) {
        var start = text.indexOf('{');
        var end = text.lastIndexOf('}');
        if (start >= 0 && end > start) {
          try {
            return JSON.parse(text.slice(start, end + 1));
          } catch (err) {
            return null;
          }
        }
        return null;
      }
    }

    function openSearch() {
      searchRoot.removeAttribute('hidden');
      document.body.style.overflow = 'hidden';
      if (searchInput) searchInput.focus();
    }

    function closeSearch() {
      searchRoot.setAttribute('hidden', '');
      document.body.style.overflow = '';
    }

    function renderProducts(products, terms) {
      if (!products || !products.length) {
        searchResults.innerHTML = '<p class="ajax-search__empty">' + emptyMessage(terms) + '</p>';
        return;
      }
      var html = '<ul class="ajax-search__grid" role="listbox">';
      products.forEach(function (product) {
        if (!product || !product.url) return;
        var src = productImage(product);
        var image = src ? '<img src="' + src + '" alt="" width="64" height="80" loading="lazy">' : '<span class="ajax-search__thumb"></span>';
        html += '<li><a class="ajax-search__item" href="' + product.url + '" role="option">' +
          image +
          '<p class="ajax-search__item-title">' + escapeHtml(product.title) + '</p>' +
          '<span class="ajax-search__item-price">' + formatMoney(product.price) + '</span>' +
          '</a></li>';
      });
      html += '</ul>';
      searchResults.innerHTML = html;
    }

    function fetchProducts(q) {
      var ajaxUrl = searchUrl + '?q=' + encodeURIComponent(q) + '&type=product&view=ajax';
      return fetch(ajaxUrl, { headers: { Accept: 'application/json' } })
        .then(function (res) { return res.text(); })
        .then(function (text) {
          var data = parseJsonSafe(text);
          var products = extractProducts(data);
          if (products.length) return products;
          var suggest = suggestUrl.replace(/\.json$/, '') + '.json?q=' + encodeURIComponent(q) +
            '&resources[type]=product&resources[limit]=8';
          return fetch(suggest).then(function (res) { return res.json(); }).then(function (suggestData) {
            return extractProducts(suggestData);
          });
        });
    }

    function runSearch() {
      var q = currentQuery();
      if (q.length < 2) {
        searchResults.innerHTML = '<p class="ajax-search__hint">' + hint + '</p>';
        return;
      }
      var thisRequest = ++requestId;
      fetchProducts(q)
        .then(function (products) {
          if (thisRequest !== requestId) return;
          renderProducts(products, currentQuery() || q);
        })
        .catch(function () {
          if (thisRequest !== requestId) return;
          searchResults.innerHTML = '<p class="ajax-search__empty">' + emptyMessage(currentQuery() || q) + '</p>';
        });
    }

    searchOpen.addEventListener('click', openSearch);
    closeBtns.forEach(function (btn) { btn.addEventListener('click', closeSearch); });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeSearch();
    });
    if (searchForm) {
      searchForm.addEventListener('submit', function (event) {
        event.preventDefault();
        runSearch();
      });
    }
    if (searchInput) {
      searchInput.addEventListener('input', function () {
        clearTimeout(timer);
        timer = setTimeout(runSearch, 250);
      });
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["learn-quiz"] && !Shopify.designMode) return;
  try {
    (function () {
    var quiz = document.querySelector('[data-skin-quiz]');
    if (!quiz) return;

    var answers = { age: '', concern: '', type: '', avoid: [], area: '' };
    var screen = 'intro';
    var images = {};
    try {
      var imageNode = quiz.querySelector('[data-quiz-images]');
      images = JSON.parse(imageNode.textContent);
    } catch (error) {
      images = {};
    }

    var labels = {
      age: { '18-25': '18–25', '26-39': '26–39', '40-50': '40–50', '50+': '50+' },
      concern: {
        dry: 'dryness and sensitivity',
        acne: 'breakouts and congestion',
        redness: 'redness and reactive patches',
        firmness: 'firmness, dark spots and uneven tone'
      },
      type: { dry: 'dry', oily: 'oily', combo: 'combination', normal: 'normal' },
      area: {
        face: 'face',
        body: 'body',
        hair: 'hair and scalp',
        fragrance: 'fragrance'
      }
    };

    function $(sel) {
      return quiz.querySelector(sel);
    }

    function show(name) {
      screen = name;
      quiz.querySelectorAll('[data-screen]').forEach(function (el) {
        var on = el.getAttribute('data-screen') === String(name);
        el.classList.toggle('is-active', on);
        if (on) el.removeAttribute('hidden');
        else el.setAttribute('hidden', '');
      });
      var progress = $('[data-quiz-progress]');
      var back = $('[data-quiz-back]');
      if (name === 'intro') {
        progress.hidden = true;
        back.textContent = '← Back';
      } else if (name === 'result') {
        progress.hidden = true;
        back.textContent = '← Back';
      } else {
        progress.hidden = false;
        var n = parseInt(name, 10);
        var pct = n * 20;
        $('[data-progress-label]').textContent = n + ' of 5';
        $('[data-progress-pct]').textContent = pct + '%';
        $('[data-progress-fill]').style.width = pct + '%';
      }
    }

    function currentChoice() {
      return quiz.querySelector('[data-screen="' + screen + '"] [data-choice]');
    }

    function valueOf(group) {
      var on = quiz.querySelector('[data-choice="' + group + '"] button.is-on');
      return on ? on.getAttribute('data-value') : '';
    }

    function multiValues(group) {
      return Array.prototype.map.call(
        quiz.querySelectorAll('[data-choice="' + group + '"] button.is-on'),
        function (btn) { return btn.getAttribute('data-value'); }
      );
    }

    quiz.addEventListener('click', function (event) {
      var btn = event.target.closest('[data-choice] button');
      if (!btn) return;
      var group = btn.parentNode;
      if (group.getAttribute('data-multi') === 'true') {
        var val = btn.getAttribute('data-value');
        if (val === 'none') {
          group.querySelectorAll('button').forEach(function (b) { b.classList.remove('is-on'); });
          btn.classList.add('is-on');
        } else {
          var none = group.querySelector('[data-value="none"]');
          if (none) none.classList.remove('is-on');
          btn.classList.toggle('is-on');
        }
      } else {
        group.querySelectorAll('button').forEach(function (b) { b.classList.remove('is-on'); });
        btn.classList.add('is-on');
      }
    });

    $('[data-quiz-start]').addEventListener('click', function () { show('1'); });

    quiz.querySelectorAll('[data-quiz-next]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var choice = currentChoice();
        if (!choice) return;
        var key = choice.getAttribute('data-choice');
        if (choice.getAttribute('data-multi') === 'true') {
          answers.avoid = multiValues(key);
          if (!answers.avoid.length) return;
        } else {
          answers[key] = valueOf(key);
          if (!answers[key]) return;
        }
        show(String(parseInt(screen, 10) + 1));
      });
    });

    $('[data-quiz-finish]').addEventListener('click', function () {
      answers.area = valueOf('area');
      if (!answers.area) return;
      finish();
    });

    $('[data-quiz-back]').addEventListener('click', function () {
      if (screen === 'intro') {
        window.history.back();
        return;
      }
      if (screen === 'result') {
        show('5');
        return;
      }
      var n = parseInt(screen, 10);
      if (n === 1) show('intro');
      else show(String(n - 1));
    });

    $('[data-quiz-retake]').addEventListener('click', function () {
      answers = { age: '', concern: '', type: '', avoid: [], area: '' };
      quiz.querySelectorAll('[data-choice] button').forEach(function (b) { b.classList.remove('is-on'); });
      if (window.history.replaceState) {
        window.history.replaceState({}, '', window.location.pathname);
      }
      show('intro');
    });

    function pickId() {
      if (answers.area === 'fragrance') return 6;
      if (answers.area === 'body') return 7;
      if (answers.area === 'hair') return 8;
      if (answers.concern === 'acne' || answers.type === 'oily') return 3;
      if (answers.concern === 'redness') return 2;
      if (answers.concern === 'firmness' && (answers.age === '40-50' || answers.age === '50+')) return 5;
      if (answers.concern === 'firmness') return 4;
      return 1;
    }

    function avoidNote() {
      var list = answers.avoid || [];
      if (list.indexOf('none') !== -1 || !list.length) return 'No extra restrictions were flagged, so the lineup stays simple and glow-forward.';
      var bits = [];
      if (list.indexOf('pregnant') !== -1) bits.push('we skipped strong retinoids and keep actives pregnancy-safer');
      if (list.indexOf('oils') !== -1) bits.push('essential-oil-heavy formulas stay off the list');
      if (list.indexOf('fragrance') !== -1) bits.push('fragrance-free options are preferred');
      return 'Noted: ' + bits.join('; ') + '.';
    }

    function profiles() {
      var skin = quiz.getAttribute('data-shop-skin');
      var face = quiz.getAttribute('data-shop-face');
      var body = quiz.getAttribute('data-shop-body');
      var hair = quiz.getAttribute('data-shop-hair');
      var fragrance = quiz.getAttribute('data-shop-fragrance');
      var newest = quiz.getAttribute('data-shop-new');
      return {
        1: {
          key: 'hydrate',
          name: 'La Roche-Posay moisture routine',
          tags: 'Double Repair moisturizer • Toleriane cleanser — for dry and tight-feeling skin',
          shop: skin,
          steps: [
            'Cleanse at night with La Roche-Posay Toleriane foaming cleanser.',
            'Press Double Repair moisturizer over face and neck while skin is slightly damp.',
            'Choose the SPF variant in the morning if you want sun protection in the same cream.',
            'Shop Skincare for both formulas.'
          ]
        },
        2: {
          key: 'sensitive',
          name: 'Toleriane gentle lineup',
          tags: 'Fragrance-conscious • Barrier-first — Toleriane cleanser and Double Repair',
          shop: skin,
          steps: [
            'Keep it short: Toleriane cleanser, then Double Repair cream.',
            'Skip stacking extra actives until skin feels calm.',
            'If a spot appears, Mighty Patch overnight — not a new acid.',
            'Shop Skincare for the two La Roche-Posay face products.'
          ]
        },
        3: {
          key: 'clear',
          name: 'PanOxyl + Mighty Patch',
          tags: 'Benzoyl peroxide wash • Overnight patches — for breakouts',
          shop: face,
          steps: [
            'Use PanOxyl 10% wash as directed, then rinse.',
            'Moisturize with Double Repair on the rest of the face.',
            'Press Mighty Patch on a visible pimple overnight.',
            'Shop Face and Skincare for both products.'
          ]
        },
        4: {
          key: 'glow',
          name: 'Mighty Patch + moisturizer',
          tags: 'Spot treatment • Daily cream — for congestion with dryness',
          shop: newest,
          steps: [
            'Cleanse with Toleriane or PanOxyl depending on how oily you run.',
            'Mighty Patch on spots at night.',
            'Double Repair cream morning and night so skin does not strip.',
            'Shop bestsellers to add the packs in one pass.'
          ]
        },
        5: {
          key: 'firm',
          name: 'Lipikar body + Double Repair face',
          tags: 'Lipikar AP+MAX • Double Repair — richer moisture for changing skin',
          shop: skin,
          steps: [
            'Face: Toleriane cleanser, then Double Repair cream.',
            'Body: Lipikar AP+MAX after the shower, on damp skin.',
            'L’Occitane Almond Shower Oil in the shower if you want a richer wash.',
            'Shop Skincare and Body.'
          ]
        },
        6: {
          key: 'fragrance',
          name: 'Sol de Janeiro + perfume edit',
          tags: 'Cheirosa mist • White Diamonds • GODA — hair, body, and perfume',
          shop: fragrance,
          steps: [
            'Spray Cheirosa mist on hair and body after moisturizer.',
            'White Diamonds is the classic eau de toilette.',
            'GODA is the concentrated perfume option.',
            'Shop Fragrance for all three.'
          ]
        },
        7: {
          key: 'body',
          name: 'L’Occitane + Lipikar',
          tags: 'Almond Shower Oil • Lipikar AP+MAX — wash then cream',
          shop: body,
          steps: [
            'Wash with L’Occitane Almond Shower Oil. It milks in water and can be a shave base.',
            'Pat dry, then apply Lipikar AP+MAX within a few minutes.',
            'Use extra cream on elbows, knees, and dry patches.',
            'Shop Body for both products.'
          ]
        },
        8: {
          key: 'hair',
          name: 'Ordinary serum, Mielle oil, Oribe cream',
          tags: 'Hair density serum • Rosemary mint oil • Supershine cream',
          shop: hair,
          steps: [
            'The Ordinary Multi-Peptide Serum on a clean scalp for density.',
            'Mielle rosemary mint oil as a pre-wash scalp treatment.',
            'Oribe Supershine cream on damp lengths for shine and smooth.',
            'Shop Hair for the three formulas.'
          ]
        }
      };
    }

    function writeAi(profile) {
      var age = labels.age[answers.age] || 'your';
      var type = labels.type[answers.type] || 'unique';
      var concern = labels.concern[answers.concern] || 'overall balance';
      var area = labels.area[answers.area] || 'skin';
      return 'Based on your answers — age ' + age + ', ' + type + ' skin, focused on ' + concern + ' across your ' + area + ' — this routine was assembled as a short, high-signal plan rather than a 12-step pile-up. ' + avoidNote() + ' The steps below are the order to follow tonight, then again in the morning where noted.';
    }

    function finish() {
      var id = pickId();
      var profile = profiles()[id];
      $('[data-result-name]').textContent = profile.name;
      $('[data-result-ai]').textContent = writeAi(profile);
      $('[data-result-tags]').textContent = profile.tags;
      $('[data-result-shop]').setAttribute('href', profile.shop);
      var steps = $('[data-result-steps]');
      steps.innerHTML = profile.steps.map(function (step) {
        return '<li>' + step + '</li>';
      }).join('');
      var img = $('[data-result-image]');
      if (images[profile.key]) img.src = images[profile.key];
      if (window.history.replaceState) {
        window.history.replaceState({}, '', '?result=' + id);
      }
      show('result');
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    var params = new URLSearchParams(window.location.search);
    var preset = parseInt(params.get('result'), 10);
    if (preset >= 1 && preset <= 8) {
      answers = { age: '26-39', concern: 'dry', type: 'dry', avoid: ['none'], area: 'face' };
      if (preset === 6) answers.area = 'fragrance';
      if (preset === 7) answers.area = 'body';
      if (preset === 8) answers.area = 'hair';
      if (preset === 3) answers.concern = 'acne';
      if (preset === 2) answers.concern = 'redness';
      if (preset === 5) { answers.concern = 'firmness'; answers.age = '50+'; }
      if (preset === 4) answers.concern = 'firmness';
      finish();
    } else {
      show('intro');
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-grid-js"] && !Shopify.designMode) return;
  try {
    (function () {
    document.addEventListener('click', function (event) {
      var openBtn = event.target.closest('[data-quick-open]');
      if (openBtn) {
        event.preventDefault();
        var card = openBtn.closest('[data-product-card]');
        var dialog = document.querySelector('[data-quick-shop]');
        if (!card || !dialog) return;
        dialog.querySelector('[data-qs-title]').textContent = card.getAttribute('data-title') || '';
        dialog.querySelector('[data-qs-price]').textContent = card.getAttribute('data-price') || '';
        dialog.querySelector('[data-qs-image]').src = card.getAttribute('data-image') || '';
        dialog.querySelector('[data-qs-id]').value = card.getAttribute('data-id') || '';
        dialog.querySelector('[data-qs-link]').href = card.getAttribute('data-url') || '#';
        var submit = dialog.querySelector('[data-qs-submit]');
        submit.disabled = card.getAttribute('data-available') === 'false';
        if (dialog.showModal) dialog.showModal();
      }

      if (event.target.closest('[data-quick-close]') || event.target.matches('[data-quick-shop]')) {
        var dialogClose = document.querySelector('[data-quick-shop]');
        if (dialogClose && dialogClose.open) dialogClose.close();
      }

      if (event.target.closest('[data-filter-open]')) {
        var drawer = document.querySelector('[data-filter-drawer]');
        if (drawer) drawer.hidden = false;
        document.body.style.overflow = 'hidden';
      }
      if (event.target.closest('[data-filter-close]') || event.target.matches('[data-filter-drawer]')) {
        var drawerClose = document.querySelector('[data-filter-drawer]');
        if (drawerClose) drawerClose.hidden = true;
        document.body.style.overflow = '';
      }
    });

    var form = document.querySelector('[data-filter-form]');
    if (form) {
      var apply = form.querySelector('[data-filter-apply]');
      var cards = Array.prototype.slice.call(document.querySelectorAll('[data-product-card]'));
      var clientTypes = form.querySelectorAll('[data-client-type]');
      var clientAvail = form.querySelector('[data-client-available]');

      function applyClient() {
        if (!clientTypes.length && !clientAvail) return;
        var types = [];
        clientTypes.forEach(function (box) {
          if (box.checked) types.push(box.value);
        });
        var onlyAvail = clientAvail && clientAvail.checked;
        var shown = 0;
        cards.forEach(function (card) {
          var typeOk = !types.length || types.indexOf(card.getAttribute('data-type')) !== -1;
          var availOk = !onlyAvail || card.getAttribute('data-available') === 'true';
          var on = typeOk && availOk;
          card.closest('li').hidden = !on;
          if (on) shown += 1;
        });
        if (apply) apply.textContent = apply.textContent.replace(/\d+/, String(shown));
      }

      form.addEventListener('change', function (event) {
        if (event.target.matches('[data-filter-sort]') && !clientTypes.length) {
          form.submit();
          return;
        }
        applyClient();
      });

      form.addEventListener('submit', function (event) {
        if (clientTypes.length || clientAvail) {
          event.preventDefault();
          applyClient();
          var drawerDone = document.querySelector('[data-filter-drawer]');
          if (drawerDone) drawerDone.hidden = true;
          document.body.style.overflow = '';
          if (event.target.querySelector('[data-filter-sort]')) {
            var sort = event.target.querySelector('[data-filter-sort]').value;
            if (sort) {
              var url = new URL(window.location.href);
              url.searchParams.set('sort_by', sort);
              window.location.href = url.toString();
            }
          }
        }
      });
    }

    var qsForm = document.querySelector('[data-qs-form]');
    if (qsForm) {
      qsForm.addEventListener('submit', function (event) {
        event.preventDefault();
        var btn = qsForm.querySelector('[data-qs-submit]');
        var original = btn.textContent;
        btn.disabled = true;
        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          body: new URLSearchParams(new FormData(qsForm)).toString()
        })
          .then(function (res) {
            if (!res.ok) throw new Error('cart');
            return res.json();
          })
          .then(function () {
            btn.textContent = original;
            btn.disabled = false;
            document.dispatchEvent(new CustomEvent('cart:updated'));
            var dialog = document.querySelector('[data-quick-shop]');
            if (dialog && dialog.open) dialog.close();
          })
          .catch(function () {
            btn.disabled = false;
          });
      });
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wishlist-drawer"] && !Shopify.designMode) return;
  try {
    (function () {
    var KEY = 'sbg-wishlist';
    var drawer = document.querySelector('[data-wish-drawer]');
    if (!drawer) return;

    var listEl = drawer.querySelector('[data-wish-list]');
    var emptyEl = drawer.querySelector('[data-wish-empty]');
    var root = drawer.getAttribute('data-root') || '/';
    var moneyFormat = drawer.getAttribute('data-money-format') || '';
    var removeLabel = drawer.getAttribute('data-remove-label') || 'Remove';

    function readWish() {
      try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; }
    }

    function writeWish(items) {
      localStorage.setItem(KEY, JSON.stringify(items));
      document.dispatchEvent(new CustomEvent('wishlist:updated'));
    }

    function formatMoney(cents) {
      var amount = (Number(cents) / 100).toFixed(2);
      if (!moneyFormat) return '$' + amount;
      return moneyFormat
        .replace(/\{\{\s*amount\s*\}\}/g, amount)
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, String(Math.round(Number(cents) / 100)))
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount.replace('.', ','));
    }

    function syncHearts() {
      var saved = readWish();
      document.querySelectorAll('[data-wishlist]').forEach(function (button) {
        var card = button.closest('[data-product-card]');
        if (!card) return;
        var on = saved.indexOf(card.getAttribute('data-handle')) !== -1;
        button.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      document.querySelectorAll('[data-wish-count]').forEach(function (el) {
        el.textContent = String(saved.length);
        el.hidden = saved.length === 0;
      });
      document.querySelectorAll('[data-wish-open]').forEach(function (el) {
        el.classList.toggle('is-active', saved.length > 0);
      });
    }

    function openDrawer() {
      drawer.hidden = false;
      document.body.style.overflow = 'hidden';
      renderList();
    }

    function closeDrawer() {
      drawer.hidden = true;
      document.body.style.overflow = '';
    }

    function renderList() {
      var saved = readWish();
      Array.prototype.slice.call(listEl.querySelectorAll('.wish-item')).forEach(function (node) {
        node.remove();
      });
      if (!saved.length) {
        if (emptyEl) emptyEl.hidden = false;
        return;
      }
      if (emptyEl) emptyEl.hidden = true;
      saved.forEach(function (handle) {
        fetch(root + 'products/' + encodeURIComponent(handle) + '.js')
          .then(function (res) {
            if (!res.ok) throw new Error('product');
            return res.json();
          })
          .then(function (product) {
            if (readWish().indexOf(handle) === -1) return;
            var row = document.createElement('div');
            row.className = 'wish-item';
            row.setAttribute('data-wish-handle', handle);

            var link = document.createElement('a');
            link.href = product.url || (root + 'products/' + handle);
            var img = document.createElement('img');
            img.src = product.featured_image || '';
            img.alt = product.title || '';
            img.width = 72;
            img.height = 72;
            link.appendChild(img);

            var meta = document.createElement('a');
            meta.href = link.href;
            meta.style.textDecoration = 'none';
            var title = document.createElement('p');
            title.className = 'wish-item__title';
            title.textContent = product.title || '';
            var price = document.createElement('p');
            price.className = 'wish-item__price';
            price.textContent = formatMoney(product.price);
            meta.appendChild(title);
            meta.appendChild(price);

            var remove = document.createElement('button');
            remove.className = 'wish-item__remove';
            remove.type = 'button';
            remove.setAttribute('data-wish-remove', handle);
            remove.setAttribute('aria-label', removeLabel);
            remove.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M18 6L6 18M6 6l12 12"/></svg>';

            row.appendChild(link);
            row.appendChild(meta);
            row.appendChild(remove);
            listEl.appendChild(row);
          })
          .catch(function () {});
      });
    }

    document.addEventListener('click', function (event) {
      if (event.target.closest('[data-wish-open]')) {
        event.preventDefault();
        openDrawer();
        return;
      }
      if (event.target.closest('[data-wish-close]') || event.target === drawer) {
        closeDrawer();
        return;
      }

      var removeBtn = event.target.closest('[data-wish-remove]');
      if (removeBtn) {
        event.preventDefault();
        var handle = removeBtn.getAttribute('data-wish-remove');
        var saved = readWish().filter(function (item) { return item !== handle; });
        writeWish(saved);
        var row = removeBtn.closest('.wish-item');
        if (row) row.remove();
        syncHearts();
        if (!saved.length && emptyEl) emptyEl.hidden = false;
        return;
      }

      var wish = event.target.closest('[data-wishlist]');
      if (wish) {
        event.preventDefault();
        var card = wish.closest('[data-product-card]');
        if (!card) return;
        var handle = card.getAttribute('data-handle');
        var saved = readWish();
        var index = saved.indexOf(handle);
        if (index === -1) saved.push(handle);
        else saved.splice(index, 1);
        writeWish(saved);
        syncHearts();
      }
    });

    document.addEventListener('wishlist:updated', syncHearts);
    syncHearts();
  })();
  } catch(e) { console.error(e); }
})();

})();
